<template>
  <b-button variant='info' size='md' @click="submit" :disabled='disabled'>
    <i class="fa fa-check"></i> {{text}}
  </b-button>
</template>

<script>
export default{
  name: 'submit-button',
  props: {
    text: {
      type: String,
      default: '提交'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  methods: {
    submit(event) {
      this.$emit('submit', event)
    }
  }
}
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/components-base/components-custom/submit-button/submit-button.vue